import { render } from "./headers.vue?vue&type=template&id=205f18a5&scoped=true"
const script = {}

import "./headers.vue?vue&type=style&index=0&id=205f18a5&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205f18a5"]])

export default __exports__